__turbopack_context__.v({
  "balance": "Leaderboard-module-scss-module__nqolcG__balance",
  "boolean": "Leaderboard-module-scss-module__nqolcG__boolean",
  "borderBottom": "Leaderboard-module-scss-module__nqolcG__borderBottom",
  "caret": "Leaderboard-module-scss-module__nqolcG__caret",
  "collectorLevel": "Leaderboard-module-scss-module__nqolcG__collectorLevel",
  "contentDropdown": "Leaderboard-module-scss-module__nqolcG__contentDropdown",
  "dMdFlex": "Leaderboard-module-scss-module__nqolcG__dMdFlex",
  "dMdNone": "Leaderboard-module-scss-module__nqolcG__dMdNone",
  "disabled": "Leaderboard-module-scss-module__nqolcG__disabled",
  "focus": "Leaderboard-module-scss-module__nqolcG__focus",
  "focusSwitch": "Leaderboard-module-scss-module__nqolcG__focusSwitch",
  "focusSwitchLabel": "Leaderboard-module-scss-module__nqolcG__focusSwitchLabel",
  "focusSwitchLabelActive": "Leaderboard-module-scss-module__nqolcG__focusSwitchLabelActive",
  "focusSwitchLabelExtraPadding": "Leaderboard-module-scss-module__nqolcG__focusSwitchLabelExtraPadding",
  "gap": "Leaderboard-module-scss-module__nqolcG__gap",
  "headerMenuFocus": "Leaderboard-module-scss-module__nqolcG__headerMenuFocus",
  "highlightedRow": "Leaderboard-module-scss-module__nqolcG__highlightedRow",
  "hodler": "Leaderboard-module-scss-module__nqolcG__hodler",
  "hodlerContainer": "Leaderboard-module-scss-module__nqolcG__hodlerContainer",
  "interactionsHeader": "Leaderboard-module-scss-module__nqolcG__interactionsHeader",
  "leaderboardTable": "Leaderboard-module-scss-module__nqolcG__leaderboardTable",
  "loader": "Leaderboard-module-scss-module__nqolcG__loader",
  "me": "Leaderboard-module-scss-module__nqolcG__me",
  "memeLabBalance": "Leaderboard-module-scss-module__nqolcG__memeLabBalance",
  "memeLabHodler": "Leaderboard-module-scss-module__nqolcG__memeLabHodler",
  "memeLabLeaderboardTable": "Leaderboard-module-scss-module__nqolcG__memeLabLeaderboardTable",
  "memeLabRank": "Leaderboard-module-scss-module__nqolcG__memeLabRank",
  "museumToggle": "Leaderboard-module-scss-module__nqolcG__museumToggle",
  "nftLeaderboardTable": "Leaderboard-module-scss-module__nqolcG__nftLeaderboardTable",
  "pageHeader": "Leaderboard-module-scss-module__nqolcG__pageHeader",
  "rank": "Leaderboard-module-scss-module__nqolcG__rank",
  "rotation": "Leaderboard-module-scss-module__nqolcG__rotation",
  "scrollContainer": "Leaderboard-module-scss-module__nqolcG__scrollContainer",
  "statsContainer": "Leaderboard-module-scss-module__nqolcG__statsContainer",
  "tdBottomPlace": "Leaderboard-module-scss-module__nqolcG__tdBottomPlace",
  "tdh": "Leaderboard-module-scss-module__nqolcG__tdh",
  "tdhBoost": "Leaderboard-module-scss-module__nqolcG__tdhBoost",
  "tdhSub": "Leaderboard-module-scss-module__nqolcG__tdhSub",
  "tdhSubNote": "Leaderboard-module-scss-module__nqolcG__tdhSubNote",
  "totalResults": "Leaderboard-module-scss-module__nqolcG__totalResults",
  "viewAllLink": "Leaderboard-module-scss-module__nqolcG__viewAllLink",
});
